module.exports = __webpack_public_path__ + "img/man-in-saleshat.b8704cb.webp";